import React from "react";
import TableCell, { TableCellProps } from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";

import { HeadingObject } from "types";
import { StyledGrid } from "components/simple";
import { Filter, Sort } from "./Actions";

interface Props {
  headData: HeadingObject;
  setFilterValue(a: string, b: string): void;
  setSortValue(a: string, b?: string): void;
}

type DataHeaderProps = Props & TableCellProps;

const DataHeader: React.FC<DataHeaderProps> = ({
  align,
  headData,
  setFilterValue,
  setSortValue,
  ...otherProps
}: DataHeaderProps) => {
  const menuCallback = (operation: string, args: string[]): void => {
    switch (operation) {
      case "filter":
        setFilterValue(args[0], args[1]);
        break;
      case "sort":
        setSortValue(args[0], args[1] === "" ? undefined : args[1]);
        break;
      default:
        break;
    }
  };

  return (
    <TableCell align={align} {...otherProps}>
      <StyledGrid
        alignItems="center"
        container
        justifyContent={align === "right" ? "flex-end" : "flex-start"}
        itemMargin="0.25rem"
        wrap="nowrap"
      >
        {headData.alt ? (
          headData.alt
        ) : headData.tooltip ? (
          <Tooltip title={headData.tooltip}>
            <span>{headData.name}</span>
          </Tooltip>
        ) : (
          headData.name
        )}
        {headData.menu && (
          <>
            {headData.menu.filter && <Filter callback={menuCallback} menuData={headData.menu} />}
            {headData.menu.sort && <Sort callback={menuCallback} menuData={headData.menu} />}
          </>
        )}
      </StyledGrid>
    </TableCell>
  );
};

export default DataHeader;
